export const colours = [
    { backgroundColour: "#70806e", textColour: "black", textSize: "56px" },
    { backgroundColour: "#acd7b9", textColour: "black", textSize: "56px" },
    { backgroundColour: "#2dcea6", textColour: "black", textSize: "56px" },
    { backgroundColour: "#154115", textColour: "white", textSize: "50px" },
    { backgroundColour: "#86d98c", textColour: "black", textSize: "48px" },
    { backgroundColour: "#0a5d42", textColour: "white", textSize: "48px" },
    { backgroundColour: "#44a8c5", textColour: "black", textSize: "48px" },
    { backgroundColour: "#2b4dd5", textColour: "white", textSize: "42px" },
    { backgroundColour: "#111969", textColour: "white", textSize: "42px" },
    { backgroundColour: "#43739a", textColour: "black", textSize: "42px" },
    { backgroundColour: "#e31ba4", textColour: "black", textSize: "38px" },
    { backgroundColour: "#EEC94D", textColour: "white", textSize: "38px" },
    { backgroundColour: "#3b3569", textColour: "white", textSize: "38px" },
    { backgroundColour: "#6b12dc", textColour: "white", textSize: "32px" },
    { backgroundColour: "#d667de", textColour: "black", textSize: "32px" },
    { backgroundColour: "#9c03d7", textColour: "white", textSize: "32px" },
    { backgroundColour: "#146181", textColour: "white", textSize: "32px" },
    { backgroundColour: "#000000", textColour: "white", textSize: "28px" },
];
